import { createReducer, on } from '@ngrx/store';
import { initialReportRequestState } from '../../state/report-request.state';
import { ReportRequestActions } from '../action-types';

export const reportRequestReducer = createReducer(
    initialReportRequestState,

    on(ReportRequestActions.loadReportRequestData, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    }),

    on(ReportRequestActions.reportRequesteDataLoaded, (state, action) => {
        return {
            ...state,
            reportRequestData: action.payload.reportRequestData,
            reportRequestDataLoaded: true,
            retrieveData: false,
            loading: false,
            error: false,
        };
    }),

    on(ReportRequestActions.reportRequesteDataLoadedError, (state, action) => {
        return {
            ...state,
            loading: false,
            error: true,
            errorMessage: action.errorMessage,
        };
    })
);
